import React from "react";
import { I18n } from "@aws-amplify/core";
import { get } from "lodash";

import CustomButton from "../Common/CustomButton";
import OverrideDialogForm from "./OverrideDialogForm";

import images from "../../assets/img/images";

const OverrideDialog = (props) => {
  const [open, setOpen] = React.useState(false);

  const openDialog = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
  };

  return (
    <>
      <CustomButton
        color="primary"
        variant="contained"
        onClick={openDialog}
        startIcon={<img src={images.overrideIconWhite} alt="override" />}
      >
        {I18n.get("site_override")}
      </CustomButton>
      
      <OverrideDialogForm
        open={open}
        closeDialog={closeDialog}
        profileType={props.profileType}
        currentProfile={props.currentProfile}
        details={props.details}
        language={props.language}
        addNote={props.addNote}
        photos={props.photos}
        tabs={props.tabs}
        lov={props.lov}
        siteId={get(props, ["log", "main", "siteId"])}
        zoneId={get(props, ["log", "main", "zoneId"])}
      />
    </>
  );
};

export default OverrideDialog;
